import { makeAutoObservable } from 'mobx';
import { validateConvictionCandle } from './validateConvictionCandle';

export class ConvictionCandleData {
  candleDuration = 1;
  minimumFirstCandleHeight = 0;
  rightColorCandle = false;
  candleClosePct = 0;
  permittedGapPct = -2147483648;

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach((field) => {
        if (field === 'candleClosePct' || field === 'permittedGapPct') {
          this[field] = Number(initialData[field]) * 100;
        } else {
          this[field] = initialData[field];
        }
      });
    }
  }

  //common methods
  resetToDefaults = () => {
    this.candleDuration = 1;
    this.minimumFirstCandleHeight = 0;
    this.rightColorCandle = false;
    this.candleClosePct = 0;
    this.permittedGapPct = -2147483648;
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const data = {
      candleDuration: this.candleDuration,
      minimumFirstCandleHeight: this.minimumFirstCandleHeight,
      rightColorCandle: this.rightColorCandle,
      candleClosePct: this.candleClosePct,
      permittedGapPct: this.permittedGapPct,
    };

    const result = validateConvictionCandle(data);
    return result;
  };

  returnJson = () => {
    return {
      candleDuration: this.candleDuration,
      minimumFirstCandleHeight: this.minimumFirstCandleHeight,
      rightColorCandle: this.rightColorCandle,
      candleClosePct: Number(this.candleClosePct) / 100,
      permittedGapPct: Number(this.permittedGapPct) / 100,
    };
  };

  //specific methods
  setCandleDuration = (number) => {
    this.candleDuration = number;
  };
  setMinimumFirstCandleHeight = (number) => {
    this.minimumFirstCandleHeight = number;
  };
  setRightColorCandle = (bool) => {
    this.rightColorCandle = bool;
  };
  setCandleClosePct = (number) => {
    this.candleClosePct = number;
  };
  setPermittedGapPct = (number) => {
    this.permittedGapPct = number;
  };
}
